export default __webpack_public_path__ + "static/media/My Path badge.aa93d8a2.svg";